module.exports = __webpack_public_path__ + "img/z04.0c941f7c.jpg";